export const HeroBannerAlphaProps = {
    titleColor: {
        type: String,
        default: '#000',
    },
    textContainerBackground: {
        type: String,
        default: '',
    },
    headlineBottomShadow: {
        type: Boolean,
        default: false,
    },
    subTitleColor: {
        type: String,
        default: '#000',
    },
    subTitleAlign: {
        type: String,
        default: 'left',
    },
    textWidth: {
        type: String,
        default: '100%',
    },
    textWidthTablet: {
        type: String,
        default: '100%',
    },
    textWidthMobile: {
        type: String,
        default: '100%',
    },
    hasGradient: {
        type: Boolean,
        default: false,
    },
    useBackgroundImage: {
        type: Boolean,
        default: false,
    },
    hideBackgroundImageOnMobile: {
        type: Boolean,
        default: false,
    },
    mobileBackgroundPositionX: {
        type: String,
        default: '',
    },
    dateTextColor: {
        type: String,
        default: '#FFF',
    },
    dateTextSize: {
        type: String,
        default: '12px',
    },
    dateMobileTextSize: {
        type: String,
        default: '12px',
    },
    removeBottomPadding: {
        type: Boolean,
        default: false,
    },

    // drop down props
    showDropdown: {
        type: Boolean,
        default: false,
    },
    dropDownHeaderBackgroundColor: {
        type: String,
        default: '#212121',
    },
    dropDownHeaderTextColor: {
        type: String,
        default: 'white',
    },
    dropDownBackgroundColor: {
        type: String,
        default: '#f3f3f3',
    },
    dropDownTextColor: {
        type: String,
        default: '#000',
    },
    dropDownTextSize: {
        type: String,
        default: '14px',
    },
};
